export const ROUTE_CONSTS = {
  CHATBOT: {
    home: '',
    chatbot: 'chatbot',
  },
  CLINIC: {
    base: 'clinics',
    clinicList: 'clinic-list',
    serviceList: 'service-list',
    categoryList: 'category-list',
    clinicDetail: 'clinic-detail/:clinicId',
    clinicCreate: 'clinic-create',
  },

  CALL_RAIL: {
    base: 'call-rail',
  },

  CAMPAIGN: {
    base: 'campaign',
    campaignList: 'campaign-list',
  },
  SERVICE: {
    base: 'services',
  },

  CATEGORY: {
    base: 'categories',
  },
  BUSINESS: {
    base: 'business',
    businessProfile: 'business-profile',
    businessNotification: 'business-notification',
    notificationSetup: 'setup',
    notificationPreferences: 'preferences',
    personalization: 'personalization',
    users: 'business/users',
    emailSmsAudit: 'email-sms-audit',
    emailSmsSubscription: 'subscription',
    emailSmsAuditHistory: 'history',
    emailSmsPackage: 'email-sms-package',
    emailSmsTrigger: 'email-sms-trigger/:communicationType/:triggerId',
    stripeSetup: 'stripe-setup',
    optedOutContact: 'opted-out-contact',
    optedOutEmailList: 'opted-out-email-list',
    optedOutSmsList: 'opted-out-sms-list',
    apiLog: 'api-log',
    emailSmsBilling: 'email-sms-billing',
    socialMediaIntegration: 'social-media-integration',
    socialMediaIntegrationCallback: 'social-media-integration-callback',
    aiLucy: 'ai-gia',
    mcpServer: 'mcp-server',
  },
  CONTACT_SETTINGS: {
    base: 'contact-settings',
    setup: 'setup',
  },
  USERS: {
    base: 'users', // Base path for user routes
    create: '', // Route for creating a user (e.g., /user)
    profile: 'profile',
    myProfile: 'edit', // Route for viewing/editing logged-in user's profile (e.g., /user/profile/edit)
    changePassword: 'change-password', // Route for change password
    edit: 'edit', // Route for editing a specific user's profile (e.g., /user/edit/:userId)
    workingScheduleById: 'working-schedule', // Route for viewing another user's working schedule (e.g., /user/working-schedule/:userId)
    vacationScheduleById: 'vacation-schedule', // Route for viewing another user's vacation schedule (e.g., /user/vacation-schedule/:userId)
    notificationConfiguration: 'notification-configuration', // Route for notification configuration
    emailVerification: 'email-verification',
  },

  REVIEWS: {
    base: 'reviews',
    home: 'review',
    location: 'location',
    customizeForm: 'customize-promt',
    editChannel: 'setup-review-destination',
    editConfiguration: 'setup-review-configuration',
    feedbackForm: 'review-feedback-form',
    manualReviewList: 'manual-review-list',
    reviewlist: 'review-list',
    feedbacklist: 'review-feedback',
    brochurePage: 'brochure-page',
    googleCallback: 'google-callback',
  },
  LANDINGPAGE: {
    base: 'landingpage',
  },
  PREVIEW: {
    base: 'preview-ui',
  },
  REDIRECT: 'redirect',
  CORE: {
    base: '',
  },
  AUTOMATIONS: {
    base: 'automations',
    create: 'create/:triggerType',
    edit: 'edit/:triggerType/:triggerId',
  },
  LEAD_STATUS_AUTOMATION: {
    base: 'lead-status-automation',
  },
  TEMPLATES: {
    base: 'templates',
  },
  FORM_BUILDER: {
    base: 'form-builder',
    onboarding: 'onboarding/:token',
    onboardingEditor: 'onboarding/editor/:token',
  },
  TASK: {
    base: 'tasks',
    todo: 'todo',
    inProgress: 'in-progress',
    completed: 'completed',
    allTask: 'all-task',
  },
  REPORTS: {
    base: 'reports',
    paidMedia: 'paid-media',
    dataStudio: 'data-studio',
    syndication: 'syndication',

    PLATFORM_REPORTS: {
      base: 'platform-reports',
      leadInsight: 'lead-insight',
      marketingEngagement: 'marketing-engagement',
      appointmentReport: 'appointment-report',
      callRailReport: 'call-rail-report',
      analytics: 'analytics',
      cliffhangerAnalytics: 'cliffhanger-analytics',
      executiveDashboard: 'executive-dashboard',
    },

    ANALYTICS: {
      usageAnalytics: 'usage-analytics',
      feedbackAnalytics: 'feedback-analytics',
    },

    MARKETING_DASHBOARD: {
      base: 'marketing-dashboard',
    },

    SERVICE_REPORTS: {
      base: 'service-reports',
      websiteScorecard: 'website-scorecard',
      websiteAnalytics: 'website-analytics',
      paidMediaAnalytics: 'paid-media-analytics',
      syndicationAnalytics: 'syndication-analytics',
    },

    // A download hub rather than a report you read on screen: pick a month, get one
    // combined PDF built from the report APIs.
    monthlyReports: 'monthly-reports',

    // Admin only: the business's account links (businessmaster) that feed the reports.
    settings: 'settings',

    // Website Report is its own top-level section rather than a tab strip inside
    // Service Reporting. `:tab` keeps all eleven views on one route config, so
    // Angular reuses the component instance and the in-flight report survives.
    WEBSITE_REPORT: {
      base: 'website-report',
      mobile: 'mobile',
      desktop: 'desktop',
      seo: 'seo',
      accountHealth: 'account-health',
      traffic: 'traffic',
      leads: 'leads',
      security: 'security',
      metaAds: 'meta-ads',
      googleAds: 'google-ads',
      gbp: 'gbp',
      callRail: 'call-rail',
    },

    GIA_ANALYTICS: {
      base: 'gia-analytics',
      usageAnalytics: 'usage-analytics',
      feedbackAnalytics: 'feedback-analytics',
      urlAnalytics: 'url-analytics',
    },

    // Monthly Meta / Google / Combined reports built by the paid media job. `paid-media` above is
    // the older embedded dashboard, hence the longer key.
    PAID_MEDIA_REPORTS: {
      base: 'paid-media-reports',
      meta: 'meta',
      google: 'google',
      combined: 'combined',
      library: 'library',
      setup: 'setup',
    },
  },
  THIRDPARTYINTEGRATION: {
    base: 'api-integration',
  },
  IMPORT_EXPORT: {
    base: 'import-files',
    list: 'list',
    upload: 'upload',
    verify: 'verify',
  },
  USERSANDPERMISSIONS: {
    base: 'users-permissions',
  },
  CLIFFHANGER: {
    base: 'cliffhanger',
    feature: 'feature',
    layout: 'layout',
  },
  INBOX: {
    base: 'inbox',
  },
  CONTACTS: {
    base: 'contacts',
  },
  APPOINTMENTS: {
    base: 'appointments',
  },
  PAYMENTS: {
    base: 'payments',
  },
  SelfAssessment: {
    base: 'self-assessment',
  },
  DENTAL_ASSESSMENT: {
    base: 'dental-assessment',
  },
  FILE_MANAGER: {
    base: 'file-manager',
  },

  SOCIAL_MEDIA: {
    base: 'social-media',
    addPost: 'add-post',
    editPost: 'edit-post',
    postList: 'posts',
  },

  API_INTEGRATION: {
    base: 'api-integration',
    apiKeys: 'api-keys',
  },
  IMPORT_FILES: {
    base: 'import-files',
  },
  //toDo: clean up in future
  AI_AGENTS: {
    base: 'ai-agents',
    active_agents: 'active-agents',
  },
  AI_LUCY: {
    base: 'ai-gia',
  },
  AI_BLOG: {
    base: 'ai-blog',
  },
  AI_PROMPTS: {
    base: 'ai-prompts',
  },
  AI_SUPPORT_AGENT: {
    base: 'ai-support',
  },
  AI_SNAPSHOTS: {
    base: 'ai-snapshots',
  },
  AI_LANDING_PAGE: {
    base: 'ai-landing-page',
  },
  AI_SEO_AUDITOR: {
    base: 'ai-seo-audit',
  },
  AI_FILE_UPLOAD: {
    base: 'ai-file-upload',
  },
  AI_SOCIAL: {
    base: 'ai-social-manager',
  },
  AI_SOCIAL_MEDIA: {
    base: 'ai-social-media',
  },
  AI_SALES: {
    base: 'ai-sales',
  },
  AI_DOCUMENT_INTELLIGENCE: {
    base: 'ai-document-intelligence',
  },
  AI_VISUALIZER: {
    base: 'ai-visualizer',
  },
  AI_CRYSTAL_BALL: {
    base: 'ai-crystal-ball',
  },
  AI_CAMPAIGN: {
    base: 'ai-campaigns',
  },
  PUBLIC_FORM: {
    base: 'public/v2/form',
    formDetails: ':hash/:formId',
  },
  EMAIL: {
    base: 'email',
    unsubscribe: 'unsubscribe',
  },
};
